// Contact Us page JS entry
import "../scss/contact.scss";
import { initContactForm } from "./contact-page.js";

document.addEventListener("DOMContentLoaded", () => {
	initContactForm();
});